class $01013842c1754b14$export$2e2bcd8739ae039 {
    _data;
    render(data) {
        if (!data || Array.isArray(data) && data.length === 0) return "error in render";
        this._data = data;
        const markup = this._generateMarkup();
        this._clear();
        this._parentEl.insertAdjacentHTML("afterbegin", markup);
    }
    toggleQuizInfoAndQues() {
        this._parentEl.classList.toggle("hidden");
        this._otherEl.classList.toggle("hidden");
    }
    // renderError(message = this._errorMessage) {
    //     console.log(this._overlay)
    //     document.querySelector(".erro_msg").innerHTML = message;
    //     this._overlay.classList.toggle("hidden");
    // }
    _clear() {
        this._parentEl.innerHTML = "";
    }
}


class $45fe5eecb55a4f67$var$QuizInfoView extends (0, $01013842c1754b14$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".quiz_info");
    _otherEl = document.querySelector(".quiz_question");
    _quesAmount = document.querySelector(".question_amount");
    addHandlerSubmit(handler) {
        this._parentEl.addEventListener("submit", function(e) {
            e.preventDefault();
            const formData = new FormData(this);
            const value = [
                ...formData.entries()
            ];
            handler(value);
        });
    }
}
var $45fe5eecb55a4f67$export$2e2bcd8739ae039 = new $45fe5eecb55a4f67$var$QuizInfoView();


const $c10fc4dd470a6ad9$export$923ea8233b386e99 = `https://opentdb.com/api.php?`;
const $c10fc4dd470a6ad9$export$7feb2688735399a6 = 1;


const $278b34025398d038$export$d047a7c56db64af4 = async function(url) {
    try {
        const res = await fetch(url);
        const data = await res.json();
        if (!res.ok) throw new Error(`${data.message} (${res.status})`);
        return data;
    } catch (err) {
        throw err;
    }
};
const $278b34025398d038$export$cb0dffe2d2ae675a = function() {
    return Math.floor(Math.random() * 4);
};


const $b5393ef87a412903$export$ca000e230c0caa3e = {
    quizInfo: {},
    questions: [],
    curPage: 1,
    questionPerPage: (0, $c10fc4dd470a6ad9$export$7feb2688735399a6),
    point: 0
};
const $b5393ef87a412903$export$1ed55773ccdb58a = async function(formData) {
    try {
        const [amount, category, difficulty, type] = formData.map((data)=>data[1] !== "any" ? data[1] : "");
        $b5393ef87a412903$export$ca000e230c0caa3e.quizInfo = {
            amount: amount,
            category: category,
            difficulty: difficulty,
            type: type
        };
        const infoData = $b5393ef87a412903$export$ca000e230c0caa3e.quizInfo;
        const urlLastPart = `${infoData.category !== "" ? `&category=${infoData.category}` : ""}${infoData.difficulty !== "" ? `&difficulty=${infoData.difficulty}` : ""}${infoData.type !== "" ? `&type=${infoData.type}` : ""}`;
        const data = await (0, $278b34025398d038$export$d047a7c56db64af4)(`${(0, $c10fc4dd470a6ad9$export$923ea8233b386e99)}amount=${infoData.amount}${urlLastPart}`);
        $b5393ef87a412903$export$ca000e230c0caa3e.questions = data.results.map((ques, i)=>{
            ques.incorrect_answers.splice((0, $278b34025398d038$export$cb0dffe2d2ae675a)(), 0, ques.correct_answer);
            return {
                questionId: i + 1,
                question: ques.question,
                correctAnswer: ques.correct_answer,
                option: ques.incorrect_answers,
                category: ques.category,
                difficulty: ques.difficulty,
                type: ques.type
            };
        });
    } catch (err) {
        throw err;
    }
};
const $b5393ef87a412903$export$7aeac0fcf5a90caf = function(page = $b5393ef87a412903$export$ca000e230c0caa3e.curPage) {
    $b5393ef87a412903$export$ca000e230c0caa3e.curPage = page;
    const start = (page - 1) * $b5393ef87a412903$export$ca000e230c0caa3e.questionPerPage;
    const end = page * $b5393ef87a412903$export$ca000e230c0caa3e.questionPerPage;
    return $b5393ef87a412903$export$ca000e230c0caa3e.questions.slice(start, end);
};
const $b5393ef87a412903$export$8a480db73aee2d66 = function(userPoin) {
    $b5393ef87a412903$export$ca000e230c0caa3e.point += userPoin;
};



class $a30f4bc6688e5ec2$var$QuestionView extends (0, $01013842c1754b14$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".question_cont");
    _question = document.querySelector(".quiz_question");
    _userAns = document.querySelector(".userAns");
    _errorMessage = "Please enter an option first :)";
    _allOptionBtn;
    constructor(){
        super();
        this._selectUserAnser();
    }
    addHandlerSubmit(handler) {
        this._question.addEventListener("submit", (e)=>{
            e.preventDefault();
            const btn = e.target.closest(".submit-quiz_question");
            // if (!btn) return;
            if (this._userAns.value) handler(+this._userAns.value);
        // else ;
        });
    }
    _generateMarkup() {
        // console.log(this._data)
        return this._data.map(this._generateMarkupPrivew).join();
    }
    _generateMarkupPrivew(ques) {
        return `
        <label class="quiz_question">${ques.questionId}. ${ques.question}</label>
        ${ques.option.map((op)=>`<button value="${op}" class="btn_hover form-control">${op}</button>`).join("")}`;
    }
    _selectUserAnser() {
        this._parentEl.addEventListener("click", this._selectUserAnserPreview.bind(this));
    }
    _selectUserAnserPreview(e) {
        e.preventDefault();
        const btn = e.target.closest(".form-control");
        if (!btn) return;
        if (this._data[0].correctAnswer === btn.value) this._userAns.value = 1;
        else this._userAns.value = 0;
        // will some chang
        this._allOptionBtn = this._parentEl.querySelectorAll(".form-control");
        this._allOptionBtn.forEach((op)=>op.classList.remove("user_click"));
        btn.classList.add("user_click");
    }
    renderRightAns() {
        this._allOptionBtn.forEach((btn)=>{
            if (btn.classList.contains("user_click")) {
                if (this._data[0].correctAnswer !== btn.value) btn.classList.add("wrong_ans");
            }
            if (btn.value === this._data[0].correctAnswer) btn.classList.add("right_ans");
            btn.setAttribute("disabled", true);
            btn.classList.remove("btn_hover");
        });
    }
    displayingUserPoint(state) {
        if (state.curPage === state.questions.length) setTimeout(()=>{
            this._question.classList.add("hidden");
            document.querySelector(".conclution").innerHTML = `Out of ${state.questions.length} question your ${state.point} right`;
            document.querySelector(".user_point").classList.remove("hidden");
        }, 1000);
    }
}
var $a30f4bc6688e5ec2$export$2e2bcd8739ae039 = new $a30f4bc6688e5ec2$var$QuestionView();



class $8b1dd470592a5768$var$PaginationView extends (0, $01013842c1754b14$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".quiz_question-btns");
    addHandler(handler) {
        this._parentEl.addEventListener("click", function(e) {
            const btn = e.target.closest(".page_btn");
            if (!btn) return;
            const goTo = btn.dataset.goto;
            handler(+goTo);
            this.innerHTML = `<button class="btn btn_hover submit-quiz_question">Submit</button>`;
        });
    }
    _generateMarkup() {
        if (this._data.curPage < this._data.questions.length) return `<button data-goto="${this._data.curPage + 1}" class="btn btn_hover page_btn">Next</button>`;
        else return '<button class="btn btn_hover submit-quiz_question">Submit</button>';
    }
}
var $8b1dd470592a5768$export$2e2bcd8739ae039 = new $8b1dd470592a5768$var$PaginationView();


const $8ce8ab0aa4e83271$var$controlQuizInfo = async function(formData) {
    try {
        // set the formData in modal 
        await $b5393ef87a412903$export$1ed55773ccdb58a(formData);
        // toggle the quiz info and quiz question 
        (0, $45fe5eecb55a4f67$export$2e2bcd8739ae039).toggleQuizInfoAndQues();
        // render question
        (0, $a30f4bc6688e5ec2$export$2e2bcd8739ae039).render($b5393ef87a412903$export$7aeac0fcf5a90caf());
    } catch (err) {
        if (err) alert("some network problem please refresh the page or try later");
    }
};
const $8ce8ab0aa4e83271$var$controlQuestion = function(userPoint) {
    // rendering right answer or wrong answer 
    (0, $a30f4bc6688e5ec2$export$2e2bcd8739ae039).renderRightAns();
    // set user point 
    $b5393ef87a412903$export$8a480db73aee2d66(userPoint);
    // render pagitination 
    (0, $8b1dd470592a5768$export$2e2bcd8739ae039).render($b5393ef87a412903$export$ca000e230c0caa3e);
    // render user point 
    (0, $a30f4bc6688e5ec2$export$2e2bcd8739ae039).displayingUserPoint($b5393ef87a412903$export$ca000e230c0caa3e);
};
const $8ce8ab0aa4e83271$var$controlPagination = function(page) {
    // render question
    (0, $a30f4bc6688e5ec2$export$2e2bcd8739ae039).render($b5393ef87a412903$export$7aeac0fcf5a90caf(page));
};
// all handler here 
const $8ce8ab0aa4e83271$var$init = function() {
    (0, $45fe5eecb55a4f67$export$2e2bcd8739ae039).addHandlerSubmit($8ce8ab0aa4e83271$var$controlQuizInfo);
    (0, $a30f4bc6688e5ec2$export$2e2bcd8739ae039).addHandlerSubmit($8ce8ab0aa4e83271$var$controlQuestion);
    (0, $8b1dd470592a5768$export$2e2bcd8739ae039).addHandler($8ce8ab0aa4e83271$var$controlPagination);
};
$8ce8ab0aa4e83271$var$init();


//# sourceMappingURL=index.360b63e5.js.map
